import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
export interface MuiSelectOption {
    label: React.ReactNode;
    value: string;
    disabled?: boolean;
}

interface MuiSelectProps {
    options: MuiSelectOption[];
    label?: string;
    defaultValue: MuiSelectOption['value'];
    onSelect: (value: MuiSelectOption['value']) => void;
    className?: string;
    defaultOpen?: boolean;
}

// TODO: Rename it to be ProductSelect, and move it to the menu folder
export const MuiSelect: React.FC<React.PropsWithChildren<MuiSelectProps>> = props => {
    const { options, label, defaultValue, onSelect, className, defaultOpen } = props;
    const [selectedValue, setSelectedValue] = React.useState(defaultValue);
    const [isOpen, setOpen] = React.useState(!!defaultOpen);

    const labelId = React.useId();
    const renderSelectOption = React.useCallback(
        (option: MuiSelectOption) => (
            <MenuItem value={option.value} key={option.value} disabled={option.disabled}>
                {option.label}
            </MenuItem>
        ),
        []
    );

    const handleValueChanged = React.useCallback(
        (event: SelectChangeEvent) => {
            setSelectedValue(event.target.value);
            onSelect(event.target.value);
        },
        [onSelect]
    );

    const handleClose = React.useCallback(() => {
        setOpen(false);
    }, []);
    const handleOpen = React.useCallback(() => {
        setOpen(true);
    }, []);

    React.useEffect(() => {
        if (defaultOpen) {
            setOpen(true);
        }
    }, [defaultOpen]);

    return (
        <FormControl sx={{ display: 'flex' }} className={className}>
            {!!label && <InputLabel id={labelId}>{label}</InputLabel>}
            <Select
                labelId={labelId}
                value={selectedValue}
                onChange={handleValueChanged}
                onClose={handleClose}
                onOpen={handleOpen}
                open={isOpen}
                variant="standard"
                MenuProps={{
                    marginThreshold: 0
                }}
            >
                {options.map(renderSelectOption)}
            </Select>
        </FormControl>
    );
};
